<template>
	<div style="margin-left: 16px;">
		<downloadcommon ref="download"></downloadcommon>
		<el-dialog title="选择文件" :visible.sync="daorudiag" width="800px" :close-on-click-modal="false" append-to-body
			v-dialogDrag>
			<!-- <minhead :headtitle="daorutitle" :isdiag="true"></minhead> -->
			<div class="Verticalcenter" style="margin-top: 82px;">
				<div class="Centerhorizontally" style="margin-left: 260px;">
					<el-input style="width: 300px;margin-right: 16px;" disabled v-model="upfilename"></el-input>

					<label style="display: flex;align-items: center;">
						<div class="Centerhorizontally bt1">选择文件</div>
						<input type="file" class="sendinput" @change="uploadFile($event)" :value="filestate" />
					</label>
				</div>
			</div>
			<div style="justify-content: right; display: flex;margin-top: 30px;">
				<div class="addstyle" style="width: 80px;margin-left: 20px;" @click="sureupload">确定</div>
				<div class="backstyle" style="width: 80px;margin-left: 20px;" @click="daorudiag = false">关闭</div>
			</div>
			<!-- <div class="buttomanniu">
                <el-button type="primary" @click="sureupload">确定</el-button>
                <el-button @click="daorudiag = false">关闭</el-button>
            </div> -->
		</el-dialog>
		<el-dialog title="税收分类编码" top="2vh" :visible.sync="shuiwbmdialog" width="1209px" :close-on-click-modal="false"
			append-to-body v-dialogDrag>

			<TaxClassificationCode :shuiwbmdialog="shuiwbmdialog" @Baocjen='Baocjen'></TaxClassificationCode>
			
		</el-dialog>
		<!-- 商品主数据 -->
		<!-- 编辑弹层 -->
		<el-dialog :title="title" :visible.sync="dialogFormVisible" width="900px" :close-on-click-modal="false">
			<!-- <minhead :Stringtitle="title" :isdiag="true"></minhead> -->
			<el-form :model="ruleForm" :rules="title == '查看商品信息' ? '' : rules" ref="ruleForm" label-width="100px"
				class="demo-ruleForm">
				<div class="demo-ruleForm-item">
					<el-form-item label="商品编号:" prop="shangpbm" :label-width="formLabelWidth">
						<el-input v-model.trim="ruleForm.shangpbm" style="width:215px"
							:disabled="title == '查看商品信息' ? true : false"></el-input>
						<el-button v-if="title == '新增商品信息'" size="mini" plain native-type="button"
							style="width: 10px;margin-left: 5px;" color="red" @click="getGoodsNumberByCode()">
							<i class="el-icon-refresh" style="width: 10px;margin-left: -7px;"></i>
						</el-button>
					</el-form-item>
					<el-form-item label="商品名称:" prop="shangpmc" :label-width="formLabelWidth">
						<el-input v-model="ruleForm.shangpmc" style="width:215px"
							:disabled="title == '查看商品信息' ? true : false"></el-input>
					</el-form-item>
				</div>

				<div class="demo-ruleForm-item">
					<el-form-item label="商品英文名称:" prop="shangpywmc" :label-width="formLabelWidth">
						<el-input v-model="ruleForm.shangpywmc" style="width:215px"
							:disabled="title == '查看商品信息' ? true : false"></el-input>
					</el-form-item>
					<el-form-item label="启用/停用:" prop="shifyx" :label-width="formLabelWidth">
						<el-select v-model="ruleForm.shifyx" :disabled="title == '查看商品信息' ? true : false">
							<el-option label="启用" value="1"></el-option>
							<el-option label="停用" value="0"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div class="demo-ruleForm-item">
					<!-- <el-form-item label="税务编码:" prop="shuiwbm" :label-width="formLabelWidth"> -->
					<!-- <el-input v-model="ruleForm.shuiwbm" style="width:215px" :disabled="title=='查看商品信息'?true:false "></el-input> -->
					<!-- </el-form-item> -->
					<el-form-item label="税务编码" prop="shuiwbm" :label-width="formLabelWidth">
						<div @click="shuiwbmName">
							<div style="width:198px;padding-left: 15px; border: 1px solid #DCDFE6;height: 32px;border-radius: 4px;"
								:class="title == '查看商品信息' ? 'hui' : ''">
								{{ ruleForm.shuiwbm }}
							</div>
							<img v-if="title == '查看商品信息' ? false : true"
								style="position:absolute; top:50%;right:5px;transform: translate(-50%,-50%); cursor: pointer;"
								width="15px" height="14px" src="../../../assets/img/pic.png" />
						</div>
					</el-form-item>

					<el-form-item label="规格型号:" prop="guigxh" :label-width="formLabelWidth">
						<el-input v-model="ruleForm.guigxh" style="width:215px"
							:disabled="title == '查看商品信息' ? true : false"></el-input>
					</el-form-item>
				</div>
				<div class="demo-ruleForm-item">
					<el-form-item label="单位:" prop="danw" :label-width="formLabelWidth">
						<el-input v-model="ruleForm.danw" style="width:215px"
							:disabled="title == '查看商品信息' ? true : false"></el-input>
					</el-form-item>
					<el-form-item label="单价:" prop="danj" :label-width="formLabelWidth">
						<el-input v-model="ruleForm.danj" style="width:215px"
							:disabled="title == '查看商品信息' ? true : false" @input="invalidForm('danj')"></el-input>
					</el-form-item>
				</div>

				<div class="demo-ruleForm-item">
					<el-form-item label="税率:" prop="shuil" :label-width="formLabelWidth">
						<el-select v-model="ruleForm.shuil" :disabled="title == '查看商品信息' ? true : false"
							style="width:215px">
							<el-option value="0.13" label="13%"></el-option>
							<el-option value="0.12" label="12%"></el-option>
							<el-option value="0.11" label="11%"></el-option>
							<el-option value="0.10" label="10%"></el-option>
							<el-option value="0.09" label="9%"></el-option>
							<el-option value="0.08" label="8%"></el-option>
							<el-option value="0.07" label="7%"></el-option>
							<el-option value="0.06" label="6%"></el-option>
							<el-option value="0.05" label="5%"></el-option>
							<el-option value="0.04" label="4%"></el-option>
							<el-option value="0.03" label="3%"></el-option>
							<el-option value="0.015" label="1.5%"></el-option>
							<el-option value="0.01" label="1%"></el-option>
							<el-option value="0.00" label="0%"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="税率类型:" prop="lingslbz" :label-width="formLabelWidth">
						<el-select style="width:215px" v-model="ruleForm.lingslbz"
							:disabled="title == '查看商品信息' ? true : false">
							<el-option label="正常税率" value=""></el-option>
							<el-option label="出口退税" value="0"></el-option>
							<el-option label="免税" value="1"></el-option>
							<el-option label="不征收" value="2"></el-option>
							<el-option label="普通零税率" value="3"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div class="demo-ruleForm-item">
					<el-form-item label="税收优惠政策:" prop="youhzcbz" :label-width="formLabelWidth">
						<el-select v-model="ruleForm.youhzcbz" :disabled="title == '查看商品信息' ? true : false"
							style="width:215px">
							<el-option label="不使用" value="0"></el-option>
							<el-option label="使用" value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="税收优惠政策说明:" :prop="ruleForm.youhzcbz == '1' ? 'youhzcsm' : ''"
						:label-width="formLabelWidth" v-if="ruleForm.youhzcbz == '1'">
						<el-select v-model="ruleForm.youhzcsm" :disabled="title == '查看商品信息' ? true : false"
							style="width:215px">
							<el-option v-for="(item, index) in newoptionlist" :key="index" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div class="demo-ruleForm-item">
					<el-form-item label="是否可见:" prop="shifkj" :label-width="formLabelWidth">
						<el-select v-model="ruleForm.shifkj" :disabled="title == '查看商品信息' ? true : false"
							style="width:215px">
							<el-option label="否" value="0"></el-option>
							<el-option label="是" value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否默认:" prop="shifmr" :label-width="formLabelWidth">
						<el-select v-model="ruleForm.shifmr" :disabled="true" style="width:215px">
							<el-option label="否" value="0"></el-option>
							<el-option label="是" value="1"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<!--				<div class="demo-ruleForm-item">-->
				<!--					<el-form-item label="参考信息1:" prop="cank1" :label-width="formLabelWidth">-->
				<!--						<el-input v-model="ruleForm.cank1" style="width:215px" :disabled="title=='查看商品信息'?true:false "></el-input>-->
				<!--					</el-form-item>-->
				<!--					<el-form-item label="参考信息2:" prop="cank2" :label-width="formLabelWidth">-->
				<!--						<el-input v-model="ruleForm.cank2" style="width:215px" :disabled="title=='查看商品信息'?true:false "></el-input>-->
				<!--					</el-form-item>-->
				<!--				</div>-->
				<!--				<div class="demo-ruleForm-item">-->
				<!--					<el-form-item label="参考信息3:" prop="cank3" :label-width="formLabelWidth">-->
				<!--						<el-input v-model="ruleForm.cank3" style="width:215px" :disabled="title=='查看商品信息'?true:false "></el-input>-->
				<!--					</el-form-item>-->
				<!--					<el-form-item label="参考信息4:" prop="cank4" :label-width="formLabelWidth">-->
				<!--						<el-input v-model="ruleForm.cank4" style="width:215px" :disabled="title=='查看商品信息'?true:false "></el-input>-->
				<!--					</el-form-item>-->
				<!--				</div>-->
				<!--				 <div class="demo-ruleForm-item">-->
				<!--					<el-form-item label="参考信息5:" prop="cank5" :label-width="formLabelWidth">-->
				<!--						<el-input v-model="ruleForm.cank5" style="width:215px" :disabled="title=='查看商品信息'?true:false "></el-input>-->
				<!--					</el-form-item>-->
				<!--				</div>-->
				<!-- 商品编码简称 隐藏提交后台 -->
				<el-input type="hidden" v-model="ruleForm.shangpbmjc"></el-input>
			</el-form>
			<div style="justify-content: right; display: flex;margin-top: 30px;">
				<div class="addstyle" style="width: 80px;margin-left: 20px;" @click="submitForm('ruleForm')">保存</div>
				<div class="backstyle" style="width: 80px;margin-left: 20px;" @click="returnForm()">返回</div>
			</div>
			<!-- <div class="buttomanniu">
                <el-button type="primary" @click="submitForm('ruleForm')" v-if="title != '查看商品信息'">保存</el-button>
                <el-button @click="returnForm()">返回</el-button>
            </div> -->
		</el-dialog>

		<!-- 头部 -->
		<!-- 		<div class="top">
                    <div class="crumbs">
                        <el-breadcrumb separator=">">
                            <el-breadcrumb-item>
                                <i class="el-icon-lx-cascades"></i>
                                主数据管理
                            </el-breadcrumb-item>
                            <el-breadcrumb-item>
                                商品主数据
                            </el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </div> -->

		<div class="area1">
			<div class="alledit" style="font-size:20px; padding:16px 16px 16px 0px">
				<!-- <el-button size="small" plain type="primary" style="width: 100px;" color="red" @click="handleAdd('', '', '新增商品信息')"
                    >新增
                    <i class="el-icon-circle-plus-outline  el-icon--right"></i>
                </el-button> -->
				<div class="addstyle" style="width: 110px; margin-right: 10px;" @click="handleAdd('', '', '新增商品信息')">
					<samp>新增</samp></div>
				<!-- 
                <el-button
                    size="small"
                    plain
                    type="primary"
                    style="width: 100px;"
                    color="red"
                    @click="handleMor('', '', '设为默认商品信息')"
                    >设为默认
                    <i class="el-icon-rank  el-icon--right"></i>
                </el-button> -->
				<div class="addstyle" style="width: 110px; margin-right: 10px;" @click="handleMor('', '', '设为默认商品信息')">
					<samp>
						设为默认
						<i class="el-icon-rank  el-icon--right"></i>
					</samp>
				</div>

				<!--  <el-button type="primary" plain style="width: 100px;" @click="forupload">
                    下载模板
                    <i class="el-icon-download  el-icon--right"></i>
                </el-button> -->
				<div class="addstyle" style="width: 110px; margin-right: 10px;" @click="forupload">
					<samp>
						下载模板
						<i class="el-icon-download  el-icon--right"></i>
					</samp>
				</div>

				<el-dropdown class="avatar-container" trigger="click" style="margin:0 10px">
					<!--          <div class="avatar-wrapper">
                        <el-button type="primary" plain> 导入 <i class="el-icon-bottom el-icon--right"></i> </el-button>
                    </div> -->
					<div class="addstyle" style="width: 110px; margin-right: 10px;">
						<samp>
							导入
							<i class="el-icon-bottom el-icon--right"></i>
						</samp>
					</div>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item @click.native="handleImport('excl')">导入模板文件</el-dropdown-item>
						<el-dropdown-item @click.native="handleImport('ukeyXml')">导入xml文件</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<!--  <el-button type="primary" @click="excelExport" plain style="width: 100px;">
                    导出
                    <i class="el-icon-upload2 el-icon--right"></i>
                </el-button> -->
				<div class="addstyle" style="width: 110px; margin-right: 10px;" @click="excelExport">
					<samp>
						导出
						<i class="el-icon-upload2 el-icon--right"></i>
					</samp>
				</div>
				<!--    <el-button size="small" plain type="danger" style="width: 100px;" color="red" @click="handleDel('', '', '删除商品信息')"
                    >删除
                    <i class="el-icon-delete  el-icon--right"></i>
                </el-button> -->
				<div class="dangestyle" style="width: 110px; margin-right: 10px;" @click="handleDel('', '', '删除商品信息')">
					<samp>
						删除
						<i class="el-icon-delete  el-icon--right"></i>
					</samp>
				</div>
			</div>
			<div class="alledit" style="font-size:20px;">
				<el-input style="width:350px" placeholder="请输入商品编号、商品名称、规格型号、单价" prefix-icon="el-icon-search"
					v-model="likeSearch" @input="forserchgroup"></el-input>
			</div>
		</div>
		<div class="alledit-table">
			<div class="tableh">
				<el-table ref="multipleTable" border :data="tableData" height="calc(100vh - 250px )"
					@selection-change="handleSelectionChange" @row-click="selectClick">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column fixed prop="shangpbm" label="商品编号" align="left" min-width="160px"
						show-overflow-tooltip></el-table-column>

					<el-table-column prop="shangpmc" label="商品名称" align="left" min-width="160px"
						show-overflow-tooltip></el-table-column>
					<el-table-column prop="shifyx" label="启用/停用" align="center" min-width="80">
						<template slot-scope="scope">
							<p v-if="scope.row.shifyx == '1'">启用</p>
							<p v-if="scope.row.shifyx == '0'">停用</p>
						</template>
					</el-table-column>
					<el-table-column prop="guigxh" width="100" label="规格型号" align="center"
						min-width="80"></el-table-column>
					<el-table-column prop="danw" width="100" label="计量单位" align="center"
						min-width="80"></el-table-column>
					<el-table-column prop="danj" label="单价" align="center" min-width="80"></el-table-column>
					<el-table-column prop="shuil" label="税率" align="center" min-width="80">
						<template slot-scope="scope">
							<p v-if="scope.row.shuil == '0.13'">13%</p>
							<p v-if="scope.row.shuil == '0.12'">12%</p>
							<p v-if="scope.row.shuil == '0.11'">11%</p>
							<p v-if="scope.row.shuil == '0.10'">10%</p>
							<p v-if="scope.row.shuil == '0.09'">9%</p>
							<p v-if="scope.row.shuil == '0.08'">8%</p>
							<p v-if="scope.row.shuil == '0.07'">7%</p>
							<p v-if="scope.row.shuil == '0.06'">6%</p>
							<p v-if="scope.row.shuil == '0.05'">5%</p>
							<p v-if="scope.row.shuil == '0.04'">4%</p>
							<p v-if="scope.row.shuil == '0.03'">3%</p>
							<p v-if="scope.row.shuil == '0.015'">1.5%</p>
							<p v-if="scope.row.shuil == '0.01'">1%</p>
							<p v-if="scope.row.shuil == '0.00'">0%</p>
						</template>
					</el-table-column>

					<el-table-column fixed="right" label="操作" width="200">
						<template slot-scope="scope">
							<el-button @click="handleView(scope.$index, scope.row, '查看商品信息')" type="text"
								size="small">预览</el-button>
							<el-button type="text" size="small"
								@click="handleEdit(scope.$index, scope.row, '编辑商品信息')">编辑</el-button>
							<el-button type="text" size="small"
								@click="handleCurDel(scope.$index, scope.row, '删除商品信息')">删除</el-button>
							<el-button type="text" size="small" @click="handleShifyx(scope.$index, scope.row, '启停')">
								<p v-if="scope.row.shifyx == '0'">启用</p>
								<p v-if="scope.row.shifyx == '1'">停用</p>
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<!-- 分页 -->
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:key="elementui_page_component_key" :current-page="currentpage" :page-sizes="[10, 20, 30, 100]"
			:page-size="pagenum" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>

<script>
	import axios from 'axios';
	import md5 from 'js-md5';
	import TaxClassificationCode from './TaxClassificationCode/index.vue';
	export default {
		components: {
			TaxClassificationCode
		},
		created() {
			// this.useropj=JSON.parse(localStorage.getItem('useropj'))
			this.getGoodsList();
		},
		methods: {
			getFirstStr(str) {  
				// 使用、分割字符串  
				let splitStr = str.split('、');  
				// 取第一个元素的首字符并返回  
				return splitStr[0];  
			},  
			convertPercentToDecimal(percent) {  
				if(!percent){
					retrun;
				}
				percent = this.getFirstStr(percent)
				// 去掉百分号，提取百分比数字
				let percentNumber = percent.slice(0, -1);
				// 将百分比数字转换为小数
				let decimalNumber = percentNumber / 100;

				return decimalNumber;
			},  
			Baocjen(e) {
				this.ruleForm.shuiwbm = e.shuisbm;
				this.ruleForm.shuil = this.convertPercentToDecimal(e.zzssl)+'';
				this.shuiwbmdialog=false;
			},
			shuiwbmName() {
				if (this.title == '查看商品信息') {
					return false;
				}
				this.selectionCount = -1;
				this.shuiwbmdialog = true;
				this.getGoodsSWBMList();
			},
			handleDel() {
				if (this.ids == '') {
					this.$message({
						type: 'error',
						message: '请选择要删除的商品主数据'
					});
					return false;
				}

				this.delGoods('0', '');
			},
			handleCurDel(index, row, title) {
				if (row.id == '') {
					this.$message({
						type: 'error',
						message: '获取商品主数据主键为空'
					});
					return false;
				}
				this.delGoods('1', row.id);
			},

			handleShifyx(index, row) {
				if (row.id == '') {
					this.$message({
						type: 'error',
						message: '获取商品主数据失败'
					});
					return false;
				}
				this.shifyxGoods(row.id, row.shifyx);
			},
			uploadFile($event) {
				this.upfilename = $event.target.files[0].name;
				var reader = new FileReader();
				let fileData = $event.target.files[0];
				let formData = new FormData();
				formData.append('uploadFile', fileData);
				this.upfile = formData;
			},
			handleMor() {
				if (this.ids == '' || this.ids.indexOf(',') != -1) {
					this.$message({
						type: 'error',
						message: '请选择单条要设置默认的商品主数据'
					});
					return false;
				}
				this.morGoods();
			},
			forupload() {
				this.downloadGoodsDefaultTemplate();
			},
			/* 接口调用操作 */
			downloadGoodsDefaultTemplate() {
				let urlTarget = 'master/downloadGoodsDefaultTemplate';
				let signParam = {
					userCode: localStorage.getItem('useropj') ? JSON.parse(localStorage.getItem('useropj'))[
						'userCode'] : 'null',
					token: localStorage.getItem('token'),
					timestamp: new Date().getTime(),
					url: urlTarget
				};
				let sign = md5(`${signParam.userCode}${signParam.token}${signParam.timestamp}${signParam.url}`);
				let url = this.$https.baseURL + 'master/downloadGoodsDefaultTemplate'; //请求下载文件的地址
				var fileName = '下载模板';
				if (this.isyxk) {
					fileName = '商品信息模板';
				}
				this.$refs.download.download(url + `?sign=${sign}&timestamp=${signParam.timestamp}`, {
					fileType: 'xls',
					fileName: fileName
				});
			},
			handleImport(type) {
				this.release();
				this.fileType = type;
				this.daorudiag = true;
			},
			excelExport() {
				let urlTarget = 'master/getGoodsExcel';
				let signParam = {
					userCode: localStorage.getItem('useropj') ? JSON.parse(localStorage.getItem('useropj'))[
						'userCode'] : 'null',
					token: localStorage.getItem('token'),
					timestamp: new Date().getTime(),
					url: urlTarget
				};
				let idList = [];
				let checkedRows = this.$refs.multipleTable.selection;
				if (checkedRows && checkedRows.length > 0) {
					checkedRows.forEach(r => {
						idList.push(r.id);
					});
				}
				let sign = md5(`${signParam.userCode}${signParam.token}${signParam.timestamp}${signParam.url}`);
				let url = this.$https.baseURL + 'master/getGoodsExcel'; //请求下载文件的地址
				this.$refs.download.download(url + `?sign=${sign}&timestamp=${signParam.timestamp}`, {
					fileType: 'xlsx',
					fileName: '商品主数据',
					serchval: this.likeSearch,
					headTitle: this.checkmeauList,
					headFiled: this.checkHeadFiled.toString(),
					ids: idList.join(',')
				});

				// let param = {
				//     serchval: '',
				//     headTitle: '',
				//     headFiled: ''
				// }
				// param.serchval = this.likeSearch;
				// param.headTitle = this.checkmeauList;
				// param.headFiled = this.checkHeadFiled.toString();
				// this.$https.fetchdowload(url, param).then(res => {
				//     const content = res.data;
				//     const blob = new Blob([content]);
				//     var date =
				//         new Date().getFullYear() +
				//         "" +
				//         (new Date().getMonth() + 1) +
				//         "" +
				//         new Date().getDate();
				//     const fileName = date + "商品主数据" + ".xls";
				//     if ("download" in document.createElement("a")) {
				//         // 非IE下载
				//         const elink = document.createElement("a");
				//         elink.download = fileName;
				//         elink.style.display = "none";
				//         elink.href = URL.createObjectURL(blob);
				//         document.body.appendChild(elink);
				//         elink.click();
				//         URL.revokeObjectURL(elink.href); // 释放URL 对象
				//         document.body.removeChild(elink);
				//     } else {
				//         // IE10+下载
				//         navigator.msSaveBlob(blob, fileName);
				//     }
				// });
				// axios.post(url,param,{responseType:"blob"})
				// 			.then(res => {
				// 				 let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
				// 				 let objectUrl = URL.createObjectURL(blob);
				// 				 window.location.href = objectUrl;
				// 			})
				// 			.catch(error => {
				// 				this.$message.error(error);
				// 			});
			},

			release() {
				this.upfilename = '';
				this.filestate = null;
				this.upfile = '';
				this.radionochoose = '';
			},
			sureupload() {
				this.uploadExcel(this.upfile);
			},
			/* 上传标准模板 */
			uploadExcel(upfile) {
				var url;
				// if (this.fileType === 'excl') {
				//     url = 'master/uploadGoodsExcel';
				// } else if (this.fileType === 'ukeyXml') {
				//     url = 'master/uploadGoodsUkeyXml';
				// }
				let params = upfile;
				this.$https.fetchPost('master/uploadGoodsExcel', params).then(res => {
					if (res.data.success) {
						this.getGoodsList();
						this.daorudiag = false;
					}
				});
			},
			handleSelectionChange(e) {
				(this.ids = ''),
				e.forEach((item, index) => {
					this.ids = this.ids + item.id + ',';
				});
				var reg = /,$/gi;
				this.ids = this.ids.replace(reg, '');
			},
			selectClick(row, column, event) {
				this.$refs.multipleTable.toggleRowSelection(row);
			},
			handleSelectionChangeTosee(e, index) {
				this.selectionCount = index;
				this.goodshuiwbmval = e.shuisbm;
				//新增商品编码简称
				this.goodshangpbmjc = e.shangpbmjc;
				/*let zzsslVal = '0'
                if (e.zzssl != null || e.zzssl != '') {
                    zzsslVal = e.zzssl.substring(0, e.zzssl.length - 1);
                }
                if (zzsslVal == '1.5') {
                    this.goodshuilval = (zzsslVal / 100).toFixed(3);
                } else {
                    this.goodshuilval = (zzsslVal / 100).toFixed(2);
                }*/

				this.goodshuilval = e.zzssl === '0' ? '0.00' : e.zzssl;
			},
			/* 选择公司 */
			// changecolom(){
			// 	this.getGoodsList()
			// 	this.getUserGoodsList()
			// },

			handleSizeChange(val) {
				this.pagenum = val;
				this.getGoodsList();
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getGoodsList();
			},
			handleSizeChangetosee(val) {
				this.pagenumtosee = val;
				this.getGoodsSWBMList();
			},
			handleCurrentChangetosee(val) {
				this.pagetosee = val;
				this.getGoodsSWBMList();
			},
			handleEdit(index, row, title) {
				this.$nextTick(() => {
					this.$refs['ruleForm'].clearValidate();
				});
				console.log(index);
				this.title = title;
				this.ruleForm = JSON.parse(JSON.stringify(row));

				this.dialogFormVisible = true;
			},

			/* 查看商品主数据 */
			handleView(index, row, title) {
				this.title = title;
				this.$nextTick(() => {
					this.$refs['ruleForm'].clearValidate();
				});
				this.dialogFormVisible = true;
				this.ruleForm = JSON.parse(JSON.stringify(row)); //商品名称
				console.log(this.ruleForm);
			},
			/* 新增商品主数据 */
			handleAdd(index, row, title) {
				this.$nextTick(() => {
					this.$refs['ruleForm'].clearValidate();
				});
				console.log(index);
				this.title = title;
				Object.keys(this.ruleForm).map(key => (this.ruleForm[key] = ''));
				console.log(this.ruleForm);
				this.ruleForm = {
					youhzcbz: '0',
					shifyx: '1',
					shuil: '0.13',
					lingslbz: '',
					shifkj: '1',
					shifmr: '0'
				};
				this.dialogFormVisible = true;
			},
			getGoodsNumberByCode() {
				this.$https.fetchPost('/master/getGoodsNumberByCode').then(res => {
					if (res.data.success) {
						var fromData = JSON.parse(JSON.stringify(this.ruleForm));
						fromData.shangpbm = res.data.obj;
						this.ruleForm = fromData;
					}
				});
			},
			submitForm(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						this.updateGoods();
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			returnForm() {
				this.dialogFormVisible = false;
				Object.keys(this.ruleForm).map(key => (this.ruleForm[key] = ''));
			},
			fixreturnForm() {
				if (this.emptyandnull(this.goodshuiwbmval)) {
					this.$message({
						type: 'error',
						message: '请选择数据'
					});
					return false;
				}
				/* if (this.goodshuilval != '0.13' && this.goodshuilval != '0.09' && this.goodshuilval != '0.06'
                    && this.goodshuilval != '0.05' && this.goodshuilval != '0.03' && this.goodshuilval != '0.015'
                    && this.goodshuilval != '0.01' && this.goodshuilval != '0.00') {
                    this.$message({
                        type: 'error',
                        message: '获取税务编码税率不合法'
                    });
                    return;
                }*/
				this.ruleForm.shuiwbm = this.goodshuiwbmval;
				this.ruleForm.shuil = this.goodshuilval;
				// 新增 商品编码简称
				this.ruleForm.shangpbmjc = this.goodshangpbmjc;
				this.$nextTick(() => {
					this.$refs['ruleForm'].clearValidate();
				});
				this.shuiwbmdialog = false;
			},
			fixForm() {
				this.shuiwbmdialog = false;
			},
			/* 所有商品列表数据搜索 */
			forserchgroup() {
				this.currentpage = 1;
				this.elementui_page_component_key++;
				this.page = 1;
				this.getGoodsList();
			},
			forserchgrouptosee() {
				this.currentpage2 = 1;
				this.elementui_page_component_key2++;
				this.getGoodsSWBMList();
			},
			/* 接口数据 */
			/* 	新增 编辑商品主数据 */
			updateGoods() {
				var url = '';
				var type = '';
				this.ruleForm.shifkj = '1';
				this.ruleForm.shifmr = '0';
				if (this.ruleForm.id == '' || this.ruleForm.id == null) {
					url = '/master/addGoods';
					type = '0';
					/*this.ruleForm.qiybh='91500115MA1K3R189Q';*/
				} else {
					url = '/master/updateGoods';
					type = '1';
				}
				let params = {
					goodsData: JSON.stringify(this.ruleForm)
				};
				this.$https.fetchPost(url, params).then(res => {
					if (res.data.success) {
						if (type == '0') {
							this.$message.success(this.$tolertJSON[4032]);
						} else {
							this.$message.success(this.$tolertJSON[4020]);
						}

						this.dialogFormVisible = false;
						this.getGoodsList();
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			/* 设为不可见 */
			delGoods(type, id) {
				let params = '';
				if (type == '0') {
					params = {
						ids: this.ids
					};
				} else if (type == '1') {
					params = {
						ids: id
					};
				}

				this.$https.fetchPost('/master/deleteGoodsList', params).then(res => {
					console.log(res);
					if (res.data.success) {
						this.$message.success(this.$tolertJSON[4034]);
						this.getGoodsList();
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			shifyxGoods(id, shifyx) {
				if (shifyx == '1') {
					//停用
					shifyx = '0';
				} else if (shifyx == '0') {
					//启用
					shifyx = '1';
				}
				let params = {
					ids: id,
					shifyx: shifyx
				};
				this.$https.fetchPost('/master/shifyxGoods', params).then(res => {
					console.log(res);
					if (res.data.success) {
						if (shifyx == '0') {
							this.$message.success(this.$tolertJSON[4036]);
						} else if (shifyx == '1') {
							this.$message.success(this.$tolertJSON[4035]);
						}
						this.getGoodsList();
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			/* 设为可见 */
			morGoods() {
				let params = {
					ids: this.ids
				};
				this.$https.fetchPost('/master/morGoods', params).then(res => {
					console.log(res);
					if (res.data.success) {
						this.$message.success(this.$tolertJSON[4033]);
						this.getGoodsList();
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			/* 同步刷新接口*/
			refreshFn() {
				var token = localStorage.getItem('token');
				console.log(token);
				let params = {
					token: token
				};
				this.$https.fetchPost('/master/synchroGoods', params).then(res => {
					console.log(res);
					if (res.data.success) {
						this.$message.success(this.$tolertJSON[4018]);
						this.getGoodsList();
					} else {
						this.$message.error(res.data.message);
					}
				});
			},

			/* 获取公司列表 */
			getGroupCompanyList(id) {
				let params = id;
				this.$https.fetchPost('sys/getGroupCompanyList', params).then(res => {
					this.Allunitlist = res.data.obj;
					if (this.Allunitlist) {
						this.nowcolom = this.Allunitlist[0].id;
						this.changecolom();
					}
				});
			},

			/* 获取商品列表数据 */
			getGoodsList() {
				let params = {
					page: this.page,
					limit: this.pagenum,
					likeSearch: this.likeSearch,
					sort: 'asc',
					order: 'id'
				};

				this.$https.fetchPost('/master/getGoodsList', params).then(res => {
					this.total = res.data.count;
					this.tableData = res.data.data;
					this.tableData.forEach(item => {
						item.shifyx = item.shifyx == 1 ? '1' : '0';
					});
				});
			},
			getGoodsSWBMList() {
				let params = {
					page: this.pagetosee,
					limit: this.pagenumtosee,
					likeSearch: this.likeSearchtosee,
					sort: 'asc',
					order: 'id'
				};
				this.$https.fetchPost('/master/getGoodsSwbmList', params).then(res => {
					console.log(res);
					this.toseetableData = res.data.data;
					this.totaltosee = res.data.count;
				});
			},
			invalidForm(type) {
				switch (type) {
					case 'danj':
						this.ruleForm.danj = this.ruleForm.danj.replace(/[^\d.]/g, '');
						break;
				}
			}
			// getUserGoodsList(){
			// 	let params = {
			// 		page: this.pagetosee,
			// 		limit: this.pagenumtosee,
			// 		search: {unitId:this.nowcolom},
			// 		likeSearch:this.likeSearchtosee,
			// 		sort: "asc",
			// 		order: "goodsCode"
			// 	}

			// 	this.$https.fetchPost('/query/getUserGoodsList', params).then(res => {
			// 		    this.totaltosee=res.data.count
			// 		    this.toseetableData=res.data.data
			// 		    this.toseetableData.forEach(item=>{
			// 		    	item.shifyx=item.shifyx==1?"1":"0"
			// 		    })
			// 	})
			// }
		},
		mounted() {
			this.$nextTick(() => {
				this.tableHeight = this.diagheight();
				this.$refs.multipleTable.doLayout();
				window.onresize = () => {
					this.tableHeight = this.diagheight();
					this.$refs.multipleTable.doLayout();
				};
			});
		},
		data() {
			var validateShangpbm = (rule, value, callback) => {
				var reg = /^[A-z0-9]+$/gi; //
				if (!reg.test(value)) {
					callback(new Error('只能输入字母和数字'));
				} else {
					callback();
				}
			};
			var validateDanj = (rule, value, callback) => {
				var reg = /^(([1-9][0-9]*)|(([0]\.\d{1,10}|[1-9][0-9]*\.\d{1,10})))$/;
				if (!reg.test(value) & this.notemptyandnull(value)) {
					callback(new Error('只能输入保留10位的金额数字'));
				} else {
					callback();
				}
			};
			var validateShangpmc = (rule, value, callback) => {
				var reg = /^[\u4e00-\u9fa5A-z0-9]+$/gi; //
				if (!reg.test(value)) {
					callback(new Error('只能输入汉字和英文字母'));
				} else {
					callback();
				}
			};

			return {
				tableHeight: '',
				selectionCount: -1,
				checkmeauList: [
					'商品编号',
					'商品名称',
					'商品英文名称',
					'启用/停用',
					'税务编码',
					'商品税目',
					'规格型号',
					'单位',
					'单价',
					'数量',
					'税率',
					'零税率标志',
					'税收优惠政策标志',
					'税收优惠政策说明',
					'参考信息一',
					'参考信息二',
					'参考信息三',
					'参考信息四',
					'参考信息五'
				],
				checkHeadFiled: [
					'shangpbm',
					'shangpmc',
					'shangpywmc',
					'shifyx',
					'shuiwbm',
					'shuimu',
					'guigxh',
					'danw',
					'danj',
					'shul',
					'shuil',
					'lingslbz',
					'youhzcbz',
					'youhzcsm',
					'cank1',
					'cank2',
					'cank3',
					'cank4',
					'cank5'
				],
				daorudiag: false,
				daorutitle: ['选择文件'],
				upfilename: '',
				filestate: '',
				upfile: '',
				newoptionlist: [{
						label: '简易征收',
						value: '1'
					},
					{
						label: '按3%简易征收',
						value: '2'
					},
					{
						label: '按5%简易征收',
						value: '3'
					},
					{
						label: '按5%简易征收减按1.5%计征',
						value: '4'
					},
					{
						label: '100%先征后退',
						value: '5'
					},
					{
						label: '50%先征后退',
						value: '6'
					},
					{
						label: '不征税',
						value: '7'
					},
					{
						label: '先征后退',
						value: '8'
					},
					{
						label: '免税',
						value: '9'
					},
					{
						label: '即征即退100%',
						value: '10'
					},
					{
						label: '即征即退70%',
						value: '11'
					},
					{
						label: '即征即退50%',
						value: '12'
					},
					{
						label: '即征即退30%',
						value: '13'
					},
					{
						label: '稀土产品',
						value: '14'
					},
					{
						label: '超税负3%即征即退',
						value: '15'
					},
					{
						label: '超税负8%即征即退',
						value: '16'
					},
					{
						label: '超税负12%即征即退',
						value: '17'
					}
				],
				sptitle: ['主数据管理', '商品主数据'],
				seeids: '', //可见用户选中id
				ids: '', //非可见用户选中id
				Allunitlist: [],
				nowcolom: '',
				isshow: true,
				// 编辑弹层
				dialogFormVisible: false,
				title: '编辑客户',
				ruleForm: {},
				rules: {
					shangpmc: [{
							required: true,
							message: '请输入商品名称',

							trigger: 'blur'
						},
						//{validator: validateShangpmc, trigger: 'blur'},
						{
							max: 100,
							message: '长度在 100个字符',
							trigger: 'blur'
						}
					],
					shangpbm: [
						// {
						//     required: true,
						//     message: '请输入商品编号',
						//     trigger: 'blur'
						// },
						//{validator: validateShangpbm, trigger: 'blur'},
						{
							max: 30,
							message: '长度在 30个字符',
							trigger: 'blur'
						}
					],
					shangpywmc: [{
						max: 100,
						message: '长度在 100个字符',
						trigger: 'blur'
					}],
					shifyx: [{
						required: true,
						message: '请选择是否启用/停用',
						trigger: 'blur'
					}],
					shifkj: [{
						required: true,
						message: '请选择是否是否可见',
						trigger: 'blur'
					}],
					shifmr: [{
						required: true,
						message: '请选择是否是否默认',
						trigger: 'blur'
					}],
					shuiwbm: [{
						required: true,
						message: '请输入税务编码',
						trigger: 'blur'
					}],
					// guigxh: [{
					// 	required: true,
					// 	message: '请输入规格型号',
					// 	trigger: 'blur'
					// }, ],
					// danw: [{
					// 	required: true,
					// 	message: '请输入单位',
					// 	trigger: 'blur'
					// },
					// { max: 50,message: '长度在 50个字符', trigger: 'blur' }
					//  ],
					danj: [{}, {
						validator: validateDanj,
						trigger: 'blur'
					}],
					shuil: [{
						required: true,
						message: '请选择税率',
						trigger: 'blur'
					}],

					youhzcbz: [{
						required: true,
						message: '请选择税收优惠政策',
						trigger: 'blur'
					}],
					youhzcsm: [{
						required: true,
						message: '请选择税收优惠政策说明',
						trigger: 'blur'
					}],
					guigxh: [{
						max: 40,
						message: '长度在 40个字符',
						trigger: 'blur'
					}]
				},
				formLabelWidth: '150px',
				search: {
					unitCode: '',
					goodsCode: '',
					goodsName: '',
					taxRate: '',
					unitPrice: '',
					taxCode: ''
				},
				shuiwbmdialog: false,
				//搜索
				likeSearch: '',
				likeSearchtosee: '',
				//area1
				tableData: [], //表格数据
				toseetableData: [],
				total: '', //总条数
				totaltosee: '',
				page: 1, //第几页
				pagetosee: 1,
				pagenum: 20, //每页条数
				pagenumtosee: 10,
				goodshuiwbmval: '',
				goodshuilval: '0.00',
				goodshangpbmjc: '', //商品编码简称
				currentpage: 1,
				elementui_page_component_key: '',
				currentpage2: 1,
				elementui_page_component_key2: '',
				fileType: 'excl'
			};
		}
	};
</script>

<style scoped="scoped" lang="less">
	.alledit-table {}

	/deep/ .el-radio__label {
		display: none;
	}

	.hui {
		background-color: #f5f7fa;
	}

	/deep/ .el-table--small td {
		padding: 4px 0;
	}

	.plain {
		/* background-color: #b3d8ff; */
		background-color: #409eff;
		opacity: 0.7;
	}

	.blue {
		background-color: #409eff;
	}

	.sendinput {
		visibility: hidden;
	}

	.bt1 {
		width: 80px;
		height: 31px;
		border: 1px solid #e5e5e5;
		border-radius: 3px;
		font-size: 14px;
		cursor: pointer;
		font-weight: 500;
		color: #2f66fc;
	}

	/* 编辑弹层 */
	.demo-ruleForm-item {
		display: flex;
	}

	.top {
		width: 100%;
		border-bottom: 1px solid #ccc;
		padding: 10px;
		box-sizing: border-box;
		margin-bottom: 10px;
	}

	.area1:extend(.between-line) {
		border-bottom: 1px solid #ccc;
		margin-right: 16px;
		box-sizing: border-box;
	}

	.arealxr:extend(.between-line) {
		border-bottom: 1px solid #ccc;
		margin-right: 10px;
		margin-right: 10px;
		box-sizing: border-box;
	}

	.alledit {
		display: flex;
		justify-content: space-between;
	}

	.el-pagination {
		text-align: center;
		margin-top: 20px;
	}

	/* .move-btn{
    text-align: center;
    margin-top: 20px;
}
/deep/ .el-icon-d-arrow-right{
    transform:rotate(-90deg);

}
/deep/ .el-icon-d-arrow-left{
    transform:rotate(-90deg);

} */

	.move-btn {
		text-align: center;
		margin-top: 20px;
	}

	.el-icon-d-arrow-left,
	.el-icon-d-arrow-right {
		transform: rotate(-90deg);
	}

	.export-img {
		width: 12px;
		height: 12px;
		margin-right: 3px;
		vertical-align: baseline;
	}
</style>